import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, filter } from 'rxjs/operators';

type State = { id: number, name: string; };

const states: State[] = [
  { id: 0, name: 'Dados 0' },
  { id: 1, name: 'Dados 1' },
  { id: 2, name: 'Dados 2' },
  { id: 3, name: 'Dados 3' },
  { id: 5, name: 'Dados 5' },
];

@Component({
  selector: 'app-typeahead',
  templateUrl: './typeahead.component.html',
  styleUrls: ['./typeahead.component.scss']
})
export class TypeaheadComponent implements OnInit {
  public model: State;
  @Input() label: string = 'label';

  constructor() { }

  ngOnInit() {
  }

  formatter = (state: State) => state.name;

  search = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    filter(term => term.length >= 1),
    map(term => states.filter(state => new RegExp(term, 'mi').test(state.name)).slice(0, 10))
  );

}
